import { render, staticRenderFns } from "./documents-updated.vue?vue&type=template&id=cf726912&"
import script from "./documents-updated.vue?vue&type=script&lang=ts&"
export * from "./documents-updated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports